import useMapMode from "@/services/store/useMapMode";
import L from "leaflet";
import { useEffect } from "react";

const useDisablePropagationInMap = ({
  ref,
  deps,
}: {
  ref: React.MutableRefObject<HTMLElement | null>;
  deps: unknown[];
}) => {
  const map = useMapMode((state) => state.map);

  useEffect(() => {
    if (!ref.current) return;
    L.DomEvent.disableScrollPropagation(ref.current);
    ref.current.onmouseenter = () => {
      map.dragging.disable();
    };
    ref.current.onmouseleave = () => {
      map.dragging.enable();
    };
  }, [ref, map, ...deps]);
};

export default useDisablePropagationInMap;
